import { createSelector } from 'reselect'

export const getCitiesLoading = createSelector(
  (state) => Boolean(state.geoObjects && state.geoObjects.cities && state.geoObjects.cities.isLoading),
  (isLoading) => isLoading
)
